const svgCache = new Map<string, SVGSVGElement | Error | undefined>()

export default svgCache
